<script lang="ts">
    import { getContext } from "svelte";
    import { toggleFullscreen } from "../../../../../modules/vu-core/dom/fullscreen";
    import { isIOS } from "../../../../../modules/vu-core/browser/is-ios";
    import type { Writable } from "svelte/store";
    import type { SkinState, State } from "../../types/state";
    let state: Writable<State> = getContext("playerState");
    let skinState: Writable<SkinState> = getContext("skinState");

    import Button from "../shared/Button.svelte";
    import Icon from "../shared/Icon.svelte";

    $: type = $skinState.isFullscreen ? "fullScreenExit" : "fullScreenEnter";

    function click() {
        toggleFullscreen(isIOS() ? $state.adapter?.video : $state.playerContainer);
    }
</script>

<Button on:click={click} label="toggle fullscreen (f)">
    <Icon {type} />
</Button>
